import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDotGrid3x3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDotGrid3x3"><Path d="M4.25 12H4.75M11.75 12H12.25M4.25 4.5H4.75M11.75 4.5H12.25M4.25 19.5H4.75M11.75 19.5H12.25M19.25 12H19.75M19.25 4.5H19.75M19.25 19.5H19.75M5.5 11H3.5V13H5.5V11ZM13 11H11V13H13V11ZM5.5 3.5H3.5V5.5H5.5V3.5ZM13 3.5H11V5.5H13V3.5ZM5.5 18.5H3.5V20.5H5.5V18.5ZM13 18.5H11V20.5H13V18.5ZM20.5 11H18.5V13H20.5V11ZM20.5 3.5H18.5V5.5H20.5V3.5ZM20.5 18.5H18.5V20.5H20.5V18.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDotGrid3x3;
